import React, {useState} from "react";

import styles from './multiSelect.module.css'
import translation from "../../Helpers/translation";
import {ArrowImage} from "../../../assets/images/svg";
import SlideUpDown from "../../Helpers/slideUpDown/slideUpDown";
import useOnclickOutside from "react-cool-onclickoutside";
import {searchHandle} from "../../Helpers/functions";
import {useHistory, useLocation} from "react-router-dom";
import queryString from "query-string";

function MultiSelect(props) {

    const history = useHistory()
    const location = useLocation()
    const queryParams = queryString.parse(location.search,{arrayFormat: 'comma'})

    const [closed, setClosed] = useState(true);

    const handleSelect = (value) => {

        let tmp = [...props.selected]
        if(tmp.includes(value)) {
            tmp.splice(tmp.indexOf(value), 1)
        } else {
            tmp = [...tmp,...[value]]
        }

        if (props.search) {
            searchHandle("ids_composers[]", tmp, "multiSelect",location, history, queryParams)
        }

        props.setSelected(tmp)
    }

    return (
        <div className={styles.container} ref={useOnclickOutside(() => setClosed(true))}>
            <button className={`${styles.openSort} ${closed ? styles.closed : ''} ${props.selected.length > 0 ? styles.active : ''}`} onClick={() => setClosed(!closed)}>
                <span className={styles.placeholder}>{props.placeholder ? props.placeholder : translation.all.searchComposers}</span>
                <span className={styles.label}>
                    {props.selected.length > 0
                        ? props.data.find((item) => parseInt(item.id) === parseInt(props.selected[0])).name
                        : props.data[0].name
                    }
                    {props.selected.length > 1
                        ? `, +${props.selected.length - 1}`
                        : null
                    }
                </span>
                <div className={styles.arrow}>
                    <ArrowImage/>
                </div>
            </button>
            <div className={styles.sortOptionsContainer}>
                <SlideUpDown closed={closed} closedStart={true}>
                    <div className={styles.sortOptionsWrapper}>
                        <div className={styles.sortOptionsWrapper}>
                            {props.data.map((item,index) => {
                                return (
                                    index !== 0 ?
                                        <button
                                            key={index}
                                            type={"button"}
                                            className={`${styles.option} ${props.selected.includes(item.id.toString()) ? styles.active :''}`}
                                            onClick={() => handleSelect(item.id.toString())}
                                        >
                                            <div className={styles.row}>
                                                <div className={styles.checkbox}/>
                                                <span className={styles.label}>
                                                    {item.name}
                                                </span>
                                            </div>
                                        </button>
                                    : null
                                )
                            })}
                        </div>
                    </div>
                </SlideUpDown>
            </div>
        </div>
    )
}

export default MultiSelect